import styled from "styled-components";
import { Search } from "lucide-react";
import { Container } from "../layout/Container";

const Section = styled.section`
  background: hsl(${({ theme }) => theme.colors.navDark});
  padding: 2.5rem 0;
`;

const Inner = styled.div`
  text-align: center;
`;

const H1 = styled.h1`
  font-size: ${({ theme }) => theme.font.heroTitle};
  font-weight: 800;
  color: hsl(${({ theme }) => theme.colors.navDarkForeground});
  margin: 0 0 0.5rem;
`;

const Lead = styled.p`
  color: hsl(${({ theme }) => theme.colors.navDarkForeground} / 0.6);
  margin: 0 auto 1.5rem;
  font-size: clamp(0.9375rem, 0.88rem + 0.25vw, 1.125rem);
  max-width: min(100%, 48rem);
`;

const SearchWrap = styled.div`
  position: relative;
  max-width: min(100%, 40rem);
  margin: 0 auto;
`;

const Icon = styled(Search)`
  position: absolute;
  left: 1rem;
  top: 50%;
  transform: translateY(-50%);
  color: hsl(${({ theme }) => theme.colors.navDarkForeground} / 0.4);
  pointer-events: none;
`;

const Input = styled.input`
  width: 100%;
  padding: 0.75rem 1rem 0.75rem 2.5rem;
  border-radius: ${({ theme }) => theme.radius.xl};
  font-size: clamp(0.9375rem, 0.88rem + 0.2vw, 1.0625rem);
  border: 1px solid hsl(${({ theme }) => theme.colors.navDarkForeground} / 0.1);
  background: hsl(${({ theme }) => theme.colors.navDarkForeground} / 0.1);
  color: hsl(${({ theme }) => theme.colors.navDarkForeground});
  outline: none;
  &::placeholder {
    color: hsl(${({ theme }) => theme.colors.navDarkForeground} / 0.4);
  }
  &:focus {
    box-shadow: 0 0 0 2px hsl(${({ theme }) => theme.colors.primary} / 0.4);
  }
`;

export default function StoresHero({ storeCount, searchQuery, onSearchChange }) {
  return (
    <Section>
      <Container>
        <Inner>
          <H1>All Stores</H1>
          <Lead>Browse coupons from {storeCount}+ stores</Lead>
          <SearchWrap>
            <Icon size={16} strokeWidth={2} />
            <Input
              type="text"
              value={searchQuery}
              onChange={(e) => onSearchChange(e.target.value)}
              placeholder="Search for a store..."
            />
          </SearchWrap>
        </Inner>
      </Container>
    </Section>
  );
}
